import { models_constants } from "./constants";
import { Link } from "react-router-dom";

export default function Models() {
  return (
    <section className="relative py-[72px] bg-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-no-repeat bg-landing-models" />

      <div className="container relative px-3">
        <div className="flex justify-between items-center mb-1 md:mb-8">
          <div>
            <p className="text-[#0165FE] font-bold mb-2 rounded-[66px] bg-[#EDF8FF] text-center p-2 w-max px-4 text-sm hidden md:block">
              Models
            </p>
            <h2 className="text-[22px] lg:text-[40px] font-bold text-black">
              Models You Can <span className="md:text-[#084DC5]">Test</span>
            </h2>
          </div>
          <Link
            to="/signup"
            className="rounded-lg bg-primary_alt border border-[#B6E4FF] py-2.5 px-4 text-white hidden md:block"
          >
            Browse All Models
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 gap-[24px] md:gap-16 items-center">
          <div className="space-y-[18px]">
            <h3 className="text-[18px] lg:text-[32px] font-bold text-[#222] md:text-black ">
              {models_constants.title}
            </h3>

            <p className="text-[#222] text-sm">
              {models_constants.description}
            </p>

            <div className="space-y-3">
              {models_constants.features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <models_constants.CheckIcon />
                  <span className="text-[#222] text-sm">{feature}</span>
                </div>
              ))}
            </div>

            <p className="text-[#222] text-sm">{models_constants.tagLine}</p>
            <Link
              className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max block text-primary_alt font-medium w-max"
              to="/signup"
            >
              Start Building Today
            </Link>
          </div>

          <div>
            <img src={models_constants.src} alt={models_constants.alt} />
          </div>
        </div>
      </div>
    </section>
  );
}
